import { useEffect, useMemo, useState } from "react";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from "./NotifPopup";
import { ModalCariBan, ModalCariBanMulti, ModalCariMT } from "./Page27_Cari";
import { PageKonten9_Show } from "./Page9_Show";
import { PageKonten9_Pict } from "./Page9_Pict";
import { ModalBanShow } from "./Page28_BanShow";
import { ShowPic } from "../components/ShowPic";

const EVENT_CABANG_ACTIONS = [
  {
    value: "laporan_khusus",
    title: "LAPORAN KHUSUS",
    description: "Catatan kondisi khusus cabang yang perlu ditindaklanjuti atau didokumentasikan.",
  },
  {
    value: "repair_ban",
    title: "REPAIR BAN DI GUDANG",
    description: "Dokumentasi Aktivitas repair/tambal ban di Gudang Cabang.",
  },
];

const KATEGORI_OPSI = ["Laporan Baru","Tindak Lanjut"];
const JENIS_LAPORAN_OPSI = ["Laporan MT", "Laporan Ban"];
const TOPIK_DEFAULT = ["Kecelakaan"];
const TOPIK_KEJADIAN_LAIN = "__KEJADIAN_LAIN__";
const KATEGORI_TINDAK_LANJUT = "Tindak Lanjut";
const isMtIdentity = (identityRaw) => /^K-/i.test(String(identityRaw || "").trim());

const isUsulanPendingEvent = (eventName) => {
  const raw = String(eventName || "").trim().toLowerCase();
  return raw.startsWith("usul");
};

const getRepairStatusOptions = (statusBeforeRaw, statusBeforePerluRepairRaw = "") => {
  const statusBefore = String(statusBeforeRaw || "").trim().toUpperCase();
  if (statusBefore === "PERLU REPAIR") {
    const statusAwalRaw = String(statusBeforePerluRepairRaw || "").trim();
    const statusAwal = statusAwalRaw.toUpperCase();
    if (statusAwal === "NT" || statusAwal === "UT") return ["UT", "CASING"];
    const vtAwal = statusAwal.match(/^VT-(\d+)(-OT)?$/);
    if (vtAwal) {
      const suffix = String(vtAwal?.[2] || "");
      return [`VT-${vtAwal[1]}${suffix}`, `UV-${vtAwal[1]}${suffix}`, "CASING"];
    }
    const uvAwal = statusAwal.match(/^UV-(\d+)(-OT)?$/);
    if (uvAwal) {
      const suffix = String(uvAwal?.[2] || "");
      return [`UV-${uvAwal[1]}${suffix}`, "CASING"];
    }
    if (statusAwal && statusAwal !== "PERLU REPAIR") {
      return Array.from(new Set([statusAwalRaw, "CASING"]));
    }
    return ["CASING"];
  }
  if (statusBefore === "NT" || statusBefore === "UT") return ["UT", "CASING"];
  const vt = statusBefore.match(/^VT-(\d+)$/);
  const uv = statusBefore.match(/^UV-(\d+)$/);
  const tier = vt?.[1] || uv?.[1] || "";
  if (tier) return [`UV-${tier}`, "CASING"];
  return [statusBefore || "-"];
};

const buildTodayKey = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
const formatTanggalLaporan = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "-";
  const base = raw.length >= 10 ? raw.slice(0, 10) : raw;
  const m = base.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return raw;
  return `${m[3]}-${m[2]}-${m[1]}`;
};

const REQ_GROUP_EVENT_CABANG_MT_PROFIL = "event-cabang-mt-profil";
const REQ_GROUP_EVENT_CABANG_TOPIK = "event-cabang-topik";
const REQ_GROUP_EVENT_CABANG_SUBMIT_LK = "event-cabang-submit-lk";
const REQ_GROUP_EVENT_CABANG_SUBMIT_REPAIR = "event-cabang-submit-repair";
const REQ_GROUP_EVENT_CABANG_TAMBAL_OPSI = "event-cabang-tambal-opsi";
const NOMOR_PREVIEW_PLACEHOLDER = "-";
const FORCED_LOCATION_GUDANG_ONLY = Object.freeze(["gudang"]);
const BLOCKED_LOCATION_OTF_ONLY = Object.freeze(["otf"]);
const buildNomorPreviewPlaceholder = ({ kodeCabang, prefix, tanggal }) => {
  const cabang = String(kodeCabang || "").trim().toUpperCase();
  const safePrefix = String(prefix || "WO").trim().toUpperCase() || "WO";
  const tgl = String(tanggal || "").trim();
  if (!cabang || !/^\d{4}-\d{2}-\d{2}$/.test(tgl)) return NOMOR_PREVIEW_PLACEHOLDER;
  const [year, month] = tgl.split("-");
  return `${cabang}/${safePrefix}/${month}/${year}/-`;
};

function ModalTambalDetail({
  open,
  row,
  opsiJenisTambal = [],
  opsiBahanTambal = [],
  onClose,
  onSave,
}) {
  const [form, setForm] = useState({
    jenis_tambal: "",
    bahan_tambal: "",
    qty_tambal: 0,
    catatan: "",
  });

  useEffect(() => {
    if (!open) return;
    setForm({
      jenis_tambal: String(row?.jenis_tambal || "").trim(),
      bahan_tambal: String(row?.bahan_tambal || "").trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      catatan: String(row?.catatan || ""),
    });
  }, [open, row]);

  const qtyTambal = Number(form.qty_tambal);
  const invalidJenisTambal = !String(form.jenis_tambal || "").trim();
  const invalidQtyTambal = !Number.isFinite(qtyTambal) || qtyTambal < 0 || qtyTambal > 4;

  if (!open) return null;

  return (
    <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
      <div className="page16-modal-card" style={{ width: "min(720px, 94vw)" }}>
        <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
          <div>
            <h5 className="mb-1">Keterangan Tambal Ban</h5>
            <small className="text-muted">{`${String(row?.seri_ban || "-")} | ID ${Number(row?.id_ban || 0) || "-"}`}</small>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Tutup
          </button>
        </div>

        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Jenis Tambal</label>
            <select
              className={`form-select ${invalidJenisTambal ? "field-required-invalid" : ""}`}
              value={form.jenis_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, jenis_tambal: e.target.value }))}
            >
              <option value="">Pilih Jenis Tambal</option>
              {(Array.isArray(opsiJenisTambal) ? opsiJenisTambal : []).map((item) => (
                <option key={`opsi-jenis-tambal-repair-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Bahan Tambal</label>
            <select
              className="form-select"
              value={form.bahan_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, bahan_tambal: e.target.value }))}
            >
              <option value="">Pilih Bahan Tambal</option>
              {(Array.isArray(opsiBahanTambal) ? opsiBahanTambal : []).map((item) => (
                <option key={`opsi-bahan-tambal-repair-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Quantity</label>
            <input
              type="number"
              min="0"
              max="4"
              step="1"
              className={`form-control ${invalidQtyTambal ? "field-required-invalid" : ""}`}
              value={Number(form.qty_tambal || 0)}
              onChange={(e) => setForm((prev) => ({ ...prev, qty_tambal: Number(e.target.value || 0) }))}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Catatan</label>
            <textarea
              rows={2}
              className="form-control"
              placeholder="Masukkan catatan tambal ban..."
              value={form.catatan}
              onChange={(e) => setForm((prev) => ({ ...prev, catatan: e.target.value }))}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
            Batal
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={invalidJenisTambal || invalidQtyTambal}
            onClick={() => onSave({
              jenis_tambal: String(form.jenis_tambal || "").trim(),
              bahan_tambal: String(form.bahan_tambal || "").trim(),
              qty_tambal: Number(form.qty_tambal || 0),
              catatan: String(form.catatan || ""),
            })}
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
}

export function Page23EventCabang({ globalOpsi, authIdentity = {}, token, setPage, resendToken = 0 }) {
  const [activeAction, setActiveAction] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCariMt, setShowCariMt] = useState(false);
  const [showCariBan, setShowCariBan] = useState(false);
  const [showTopikModal, setShowTopikModal] = useState(false);
  const [topikBaru, setTopikBaru] = useState("");
  const [attachmentsLaporanKhusus, setAttachmentsLaporanKhusus] = useState([]);
  const [laporanKhususItems, setLaporanKhususItems] = useState([]);
  const [attachmentsRepairBan, setAttachmentsRepairBan] = useState([]);
  const [invalidCaptionIndexesLaporanKhusus, setInvalidCaptionIndexesLaporanKhusus] = useState([]);
  const [invalidCaptionIndexesRepairBan, setInvalidCaptionIndexesRepairBan] = useState([]);
  const [invalidCaptionIndexesByItemKey, setInvalidCaptionIndexesByItemKey] = useState({});
  const [opsiTopikDinamis, setOpsiTopikDinamis] = useState([]);
  const [mtProfilMap, setMtProfilMap] = useState({});
  const [mtDetailMap, setMtDetailMap] = useState({});
  const [showDetailMtPage, setShowDetailMtPage] = useState(false);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);
  const [showBanDetailModal, setShowBanDetailModal] = useState(false);
  const [showTindakLanjutPicker, setShowTindakLanjutPicker] = useState(false);
  const [loadingTindakLanjutRows, setLoadingTindakLanjutRows] = useState(false);
  const [tindakLanjutRows, setTindakLanjutRows] = useState([]);
  const [tindakLanjutScope, setTindakLanjutScope] = useState("cabang");
  const [tindakLanjutHistoryRows, setTindakLanjutHistoryRows] = useState([]);
  const [selectedTindakLanjutNomor, setSelectedTindakLanjutNomor] = useState("");
  const [selectedTindakLanjutRow, setSelectedTindakLanjutRow] = useState(null);
  const [showLampiranTindakLanjut, setShowLampiranTindakLanjut] = useState(false);
  const [activeLampiranHistoryRow, setActiveLampiranHistoryRow] = useState(null);
  const [isSubmittingRepair, setIsSubmittingRepair] = useState(false);
  const [openRepairBanModal, setOpenRepairBanModal] = useState(false);
  const [selectedRepairBanRows, setSelectedRepairBanRows] = useState([]);
  const [selectedRepairBanIds, setSelectedRepairBanIds] = useState([]);
  const [showTambalDetailModal, setShowTambalDetailModal] = useState(false);
  const [activeTambalDetailBanId, setActiveTambalDetailBanId] = useState(0);
  const [opsiJenisTambal, setOpsiJenisTambal] = useState([]);
  const [opsiBahanTambal, setOpsiBahanTambal] = useState([]);
  const { showNotif } = useNotification();

  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const isPusat = kodeCabangUser === "C-1";
  const idUserAktif = Number(authIdentity?.id || 0);
  const namaUser = String(authIdentity?.nama || "").trim();
  const usernameUser = String(authIdentity?.username || "").trim();

  const opsiCabang = useMemo(() => {
    const base = Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : [];
    if (isPusat) return base;
    return base.filter((x) => String(x?.kode_cabang || "").trim() === kodeCabangUser);
  }, [globalOpsi?.opsiCabang, isPusat, kodeCabangUser]);

  const namaCabangByKode = useMemo(() => {
    const map = new Map();
    (Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : []).forEach((x) => {
      map.set(String(x?.kode_cabang || "").trim(), String(x?.nama_cabang || "").trim());
    });
    return map;
  }, [globalOpsi?.opsiCabang]);

  const opsiMtSemua = Array.isArray(globalOpsi?.opsiMT) ? globalOpsi.opsiMT : [];
  const opsiBanSemua = Array.isArray(globalOpsi?.opsiBan) ? globalOpsi.opsiBan : [];
  const nopolByIdMt = useMemo(() => {
    const map = new Map();
    opsiMtSemua.forEach((item) => {
      const idMt = String(item?.id_mt || "").trim();
      const nopol = String(item?.nopol || "").trim();
      if (idMt && nopol) map.set(idMt, nopol);
    });
    return map;
  }, [opsiMtSemua]);
  const seriBanByIdBan = useMemo(() => {
    const map = new Map();
    opsiBanSemua.forEach((item) => {
      const idBan = String(Number(item?.id_ban || 0) || "").trim();
      const seriBan = String(item?.seri_ban || "").trim();
      if (idBan && seriBan) map.set(idBan, seriBan);
    });
    return map;
  }, [opsiBanSemua]);
  const resolveLaporanIdentityLabel = (row) => {
    const identity = String(row?.identity || "").trim();
    if (isMtIdentity(identity)) {
      return String(row?.nopol || nopolByIdMt.get(identity) || identity || "-").trim();
    }
    const idBan = String(Number(row?.id_ban || row?.ban_id || identity || 0) || "").trim();
    return String(row?.seri_ban || seriBanByIdBan.get(idBan) || identity || "-").trim();
  };

  const [form, setForm] = useState({
    kodeCabang: isPusat ? "" : kodeCabangUser,
    nomor: NOMOR_PREVIEW_PLACEHOLDER,
    tanggal: buildTodayKey(),
    kategori: "",
    topik: "",
    jenisLaporan: JENIS_LAPORAN_OPSI[0],
    idMt: "",
    nopolMt: "",
    idBan: "",
    seriBan: "",
    uraian: "",
    status_tindak_lanjut: "notdone",
    checkValidasi: false,
    namaPemeriksa: namaUser,
  });
  const [repairForm, setRepairForm] = useState({
    kodeCabang: isPusat ? "" : kodeCabangUser,
    nomor: NOMOR_PREVIEW_PLACEHOLDER,
    tanggal: buildTodayKey(),
    checkValidasi: false,
    namaPemeriksa: namaUser,
  });
  const selectedMt = useMemo(
    () => opsiMtSemua.find((x) => String(x?.id_mt || "").trim() === String(form?.idMt || "").trim()) || null,
    [opsiMtSemua, form?.idMt]
  );
  const isHeaderLaporanReady =
    Boolean(String(form?.kodeCabang || "").trim()) && Boolean(String(form?.nomor || "").trim());
  const isPickerLaporanReady = Boolean(
    String(form?.kodeCabang || "").trim()
    && String(form?.kategori || "").trim()
    && (String(form?.kategori || "").trim() === KATEGORI_TINDAK_LANJUT
      ? true
      : Boolean(String(form?.topik || "").trim()))
  );
  const isKategoriTindakLanjut = String(form?.kategori || "").trim() === KATEGORI_TINDAK_LANJUT;
  const laporanKhususItemsAktif = useMemo(
    () => (Array.isArray(laporanKhususItems) ? laporanKhususItems : []),
    [laporanKhususItems]
  );
  const invalidLaporanCabang = activeAction === "laporan_khusus" && !String(form?.kodeCabang || "").trim();
  const invalidLaporanKategori = activeAction === "laporan_khusus" && !String(form?.kategori || "").trim();
  const invalidLaporanTopik = activeAction === "laporan_khusus" && !isKategoriTindakLanjut && !String(form?.topik || "").trim();
  const invalidLaporanPetugas = activeAction === "laporan_khusus" && !String(form?.namaPemeriksa || "").trim();
  const isLaporanItemIdentityValid = (item) => {
    const type = String(item?.type || "").trim();
    if (type === "mt") return Boolean(String(item?.id_mt || "").trim());
    if (type === "ban") return Boolean(String(item?.id_ban || "").trim());
    return false;
  };
  const isLaporanItemUraianInvalid = (item) => {
    const uraian = String(item?.uraian || "").trim();
    return !uraian || uraian.length > 500;
  };
  const isLaporanItemStatusInvalid = (item) => {
    const status = String(item?.status_topik || "").trim().toLowerCase();
    return status !== "done" && status !== "notdone";
  };
  const laporanKhususItemCandidates = laporanKhususItemsAktif.filter(isLaporanItemIdentityValid);
  const invalidLaporanItemKosong = activeAction === "laporan_khusus"
    && !isKategoriTindakLanjut
    && isPickerLaporanReady
    && laporanKhususItemCandidates.length === 0;
  const invalidTindakLanjutSelection = activeAction === "laporan_khusus"
    && isKategoriTindakLanjut
    && isPickerLaporanReady
    && !selectedTindakLanjutRow?.id;
  const invalidTindakLanjutUraian = activeAction === "laporan_khusus"
    && isKategoriTindakLanjut
    && Boolean(selectedTindakLanjutRow?.id)
    && !String(form?.uraian || "").trim();
  const isLaporanBaruReady = !isKategoriTindakLanjut
    && !invalidLaporanCabang
    && !invalidLaporanKategori
    && !invalidLaporanTopik
    && !invalidLaporanPetugas
    && laporanKhususItemCandidates.length > 0
    && laporanKhususItemCandidates.every((item) => !isLaporanItemUraianInvalid(item) && !isLaporanItemStatusInvalid(item));
  const isLaporanTindakLanjutReady = isKategoriTindakLanjut
    && !invalidLaporanCabang
    && !invalidLaporanKategori
    && !invalidLaporanPetugas
    && Boolean(selectedTindakLanjutRow?.id)
    && Boolean(String(form?.uraian || "").trim());
  const isLaporanKhususSubmitReady = activeAction === "laporan_khusus"
    && isHeaderLaporanReady
    && (isKategoriTindakLanjut ? isLaporanTindakLanjutReady : isLaporanBaruReady);
  const invalidRepairCabang = activeAction === "repair_ban" && !String(repairForm?.kodeCabang || "").trim();
  const invalidRepairBanSelection = activeAction === "repair_ban" && selectedRepairBanRows.length === 0;
  const invalidRepairUser = activeAction === "repair_ban" && !String(repairForm?.namaPemeriksa || "").trim();
  const isRepairRowDetailInvalid = (row) => {
    const qtyTambal = Number(row?.qty_tambal);
    return !String(row?.jenis_tambal || "").trim()
      || !Number.isFinite(qtyTambal)
      || qtyTambal < 0
      || qtyTambal > 4;
  };
  const isRepairRowsValid = selectedRepairBanRows.length > 0
    && selectedRepairBanRows.every((row) => (
      Boolean(String(row?.status_after || "").trim())
      && !isRepairRowDetailInvalid(row)
    ));
  const isRepairSubmitReady = activeAction === "repair_ban"
    && !invalidRepairCabang
    && !invalidRepairUser
    && isRepairRowsValid;
  const selectedTindakLanjutOwnerCabang = String(selectedTindakLanjutRow?.kode_cabang || "").trim().toUpperCase();
  const canCloseTindakLanjut = Boolean(
    selectedTindakLanjutOwnerCabang
    && (isPusat || selectedTindakLanjutOwnerCabang === kodeCabangUser.toUpperCase())
  );
  const activeTambalDetailRow = useMemo(
    () => (Array.isArray(selectedRepairBanRows) ? selectedRepairBanRows : [])
      .find((row) => Number(row?.id_ban || 0) === Number(activeTambalDetailBanId || 0)) || null,
    [selectedRepairBanRows, activeTambalDetailBanId]
  );

  const opsiTopik = useMemo(() => {
    const merged = [...TOPIK_DEFAULT, ...opsiTopikDinamis, String(form?.topik || "")]
      .map((x) => String(x || "").trim())
      .filter(Boolean);
    return Array.from(new Set(merged));
  }, [opsiTopikDinamis, form?.topik]);

  const resetFormLaporan = () => {
    setForm((prev) => ({
      ...prev,
      nomor: NOMOR_PREVIEW_PLACEHOLDER,
      tanggal: buildTodayKey(),
      kategori: "",
      topik: "",
      jenisLaporan: JENIS_LAPORAN_OPSI[0],
      idMt: "",
      nopolMt: "",
      idBan: "",
      seriBan: "",
      uraian: "",
      status_tindak_lanjut: "notdone",
      checkValidasi: false,
      namaPemeriksa: namaUser,
    }));
    setAttachmentsLaporanKhusus([]);
    setLaporanKhususItems([]);
    setInvalidCaptionIndexesLaporanKhusus([]);
    setInvalidCaptionIndexesByItemKey({});
    setSelectedTindakLanjutNomor("");
    setSelectedTindakLanjutRow(null);
    setTindakLanjutHistoryRows([]);
    setActiveLampiranHistoryRow(null);
    setTopikBaru("");
    setShowTopikModal(false);
  };

  const loadLaporanTindakLanjut = async (kodeCabang, scope = tindakLanjutScope) => {
    const cabang = String(kodeCabang || "").trim();
    const normalizedScope = scope === "all" ? "all" : "cabang";
    if (!cabang) {
      setTindakLanjutRows([]);
      return;
    }
    try {
      setLoadingTindakLanjutRows(true);
      const { data } = await api.get(`${backendPort}/api/main/load_laporan_khusus_tindak_lanjut`, {
        params: { kode_cabang: cabang, scope: normalizedScope },
        timeout: 120000,
      });
      const rows = Array.isArray(data?.rows) ? data.rows : [];
      setTindakLanjutRows(rows);
    } catch (err) {
      console.error(err);
      setTindakLanjutRows([]);
      showNotif("error", err?.response?.data?.message || "Gagal memuat data tindak lanjut.");
    } finally {
      setLoadingTindakLanjutRows(false);
    }
  };

  const openTindakLanjutPicker = async (scope = tindakLanjutScope) => {
    const cabang = String(form?.kodeCabang || "").trim();
    if (!cabang) {
      showNotif("error", "Pilih cabang terlebih dahulu.");
      return;
    }
    await loadLaporanTindakLanjut(cabang, scope);
    setShowTindakLanjutPicker(true);
  };

  const handleTindakLanjutScopeChange = async (scopeRaw) => {
    const scope = scopeRaw === "all" ? "all" : "cabang";
    setTindakLanjutScope(scope);
    setSelectedTindakLanjutNomor("");
    await loadLaporanTindakLanjut(form?.kodeCabang, scope);
  };

  const loadTindakLanjutChain = async (startId) => {
    const id = Number(startId || 0);
    if (!Number.isFinite(id) || id <= 0) {
      setTindakLanjutHistoryRows([]);
      return false;
    }
    try {
      const { data } = await api.get(`${backendPort}/api/main/load_laporan_khusus_tindak_lanjut_chain/${id}`, {
        timeout: 120000,
      });
      const rows = Array.isArray(data?.rows) ? data.rows : [];
      setTindakLanjutHistoryRows(rows);
      setSelectedTindakLanjutRow(rows[0] || null);
      const ownerCabang = String(rows?.[0]?.kode_cabang || "").trim().toUpperCase();
      if (kodeCabangUser) {
        setForm((prev) => ({
          ...prev,
          nomor: buildNomorPreviewPlaceholder({
            kodeCabang: kodeCabangUser,
            prefix: "LK",
            tanggal: prev?.tanggal,
          }),
        }));
      }
      if (!isPusat && ownerCabang && ownerCabang !== kodeCabangUser.toUpperCase()) {
        setForm((prev) => ({ ...prev, status_tindak_lanjut: "notdone" }));
      }
      return true;
    } catch (err) {
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal memuat histori tindak lanjut.");
      return false;
    }
  };

  const handleKategoriLaporanChange = async (value) => {
    const kategori = String(value || "").trim();
    setForm((prev) => ({ ...prev, kategori, uraian: "" }));
    setAttachmentsLaporanKhusus([]);
    if (kategori !== KATEGORI_TINDAK_LANJUT) {
      setSelectedTindakLanjutNomor("");
      setSelectedTindakLanjutRow(null);
      setTindakLanjutHistoryRows([]);
      await loadNomorLaporan(form?.kodeCabang, form?.tanggal);
      return;
    }
    setTindakLanjutScope("cabang");
    await openTindakLanjutPicker("cabang");
  };

  useEffect(() => {
    const loadMtProfil = async () => {
      try {
        api.cancelPendingRequests({ group: REQ_GROUP_EVENT_CABANG_MT_PROFIL, reason: "Refresh mt profil event cabang" });
        const { data } = await api.get(`${backendPort}/api/main/mt_profil`, {
          requestGroup: REQ_GROUP_EVENT_CABANG_MT_PROFIL,
          timeout: 120000,
        });
        const rows = Array.isArray(data) ? data : [];
        const mapped = {};
        rows.forEach((row) => {
          const idMt = String(row?.id_mt || "").trim();
          if (!idMt) return;
          mapped[idMt] = {
            roda: Number(row?.roda || 16),
            cadangan: Number(row?.cadangan || 3),
          };
        });
        setMtProfilMap(mapped);
        const fullMap = {};
        rows.forEach((row) => {
          const idMt = String(row?.id_mt || "").trim();
          if (!idMt) return;
          fullMap[idMt] = row;
        });
        setMtDetailMap(fullMap);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error(err);
        setMtProfilMap({});
        setMtDetailMap({});
      }
    };
    //loadMtProfil();
  }, [resendToken]);

  const loadTopikLaporanKhusus = async () => {
    try {
      api.cancelPendingRequests({ group: REQ_GROUP_EVENT_CABANG_TOPIK, reason: "Refresh topik laporan khusus" });
      const { data } = await api.get(`${backendPort}/api/main/load_laporan_khusus_topik`, {
        requestGroup: REQ_GROUP_EVENT_CABANG_TOPIK,
        timeout: 120000,
      });
      const list = Array.isArray(data?.rows) ? data.rows : [];
      const topikList = list
        .map((x) => String(x?.topik || "").trim())
        .filter(Boolean);
      setOpsiTopikDinamis(Array.from(new Set(topikList)));
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      setOpsiTopikDinamis([]);
    }
  };

  const loadNomorLaporan = async (kodeCabang, tanggal) => {
    setForm((prev) => ({
      ...prev,
      nomor: buildNomorPreviewPlaceholder({
        kodeCabang,
        prefix: "LK",
        tanggal,
      }),
    }));
  };

  const loadNomorRepair = async (kodeCabang, tanggal) => {
    setRepairForm((prev) => ({
      ...prev,
      nomor: buildNomorPreviewPlaceholder({
        kodeCabang,
        prefix: "REPAIR",
        tanggal,
      }),
    }));
  };

  const handleOpenPilihBanRepair = async () => {
    const kodeCabang = String(repairForm.kodeCabang || "").trim();
    if (!kodeCabang) {
      showNotif("error", "Pilih cabang terlebih dahulu.");
      return;
    }
    setOpenRepairBanModal(true);
  };

  const handleSelesaiPilihBanRepair = (rows = [], ids = []) => {
    const normalizedIds = Array.from(
      new Set((Array.isArray(ids) ? ids : []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0))
    );
    const rowsById = new Map(
      (Array.isArray(rows) ? rows : [])
        .map((row) => ({
          id_ban: Number(row?.id_ban || 0),
          seri_ban: String(row?.seri_ban || "").trim(),
          status: String(row?.status_now || row?.status || "").trim(),
          status_sebelum_perlu_repair: String(row?.status_sebelum_perlu_repair || "").trim(),
          place: String(row?.place_now || row?.place || "").trim(),
        }))
        .filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0)
        .map((row) => [row.id_ban, row])
    );
    const prevById = new Map(
      (Array.isArray(selectedRepairBanRows) ? selectedRepairBanRows : [])
        .map((row) => [Number(row?.id_ban || 0), row])
        .filter(([id]) => Number.isFinite(id) && id > 0)
    );
    const isEligibleRepairRow = (row) => {
      const place = String(row?.place || "").trim().toLowerCase();
      const status = String(row?.status || "").trim().toUpperCase();
      if (!place && !status) return false;
      const isGudang = place.startsWith("gudang#");
      const isNotDonePlace = place === "gudang#notdone";
      const isBlockedStatus = status.startsWith("DISPOSED") || status.startsWith("UNTRACKED");
      return isGudang && !isNotDonePlace && !isBlockedStatus;
    };
    const eligibleIds = normalizedIds.filter((idBan) => {
      const row = rowsById.get(Number(idBan)) || prevById.get(Number(idBan)) || {};
      return isEligibleRepairRow({
        status: String(row?.status || row?.status_before || "").trim(),
        place: String(row?.place || "").trim(),
      });
    });
    const removedCount = normalizedIds.length - eligibleIds.length;
    setSelectedRepairBanIds(eligibleIds);
    const mappedRows = eligibleIds.map((idBan) => {
      const base = rowsById.get(Number(idBan)) || prevById.get(Number(idBan)) || {};
      const statusBefore = String(base?.status || base?.status_before || "").trim();
      const statusSebelumPerluRepair = String(base?.status_sebelum_perlu_repair || "").trim();
      const opsiStatus = getRepairStatusOptions(statusBefore, statusSebelumPerluRepair);
      return {
        id_ban: Number(idBan),
        seri_ban: String(base?.seri_ban || "").trim(),
        status_before: statusBefore,
        status_sebelum_perlu_repair: statusSebelumPerluRepair,
        status_after: String(base?.status_after || opsiStatus?.[0] || statusBefore || "").trim(),
        jenis_repair: String(base?.jenis_repair || "Tambal").trim() || "Tambal",
        qty_tambal: Number.isFinite(Number(base?.qty_tambal ?? base?.patch)) ? Number(base?.qty_tambal ?? base?.patch) : 0,
        jenis_tambal: String(base?.jenis_tambal || "").trim(),
        bahan_tambal: String(base?.bahan_tambal || "").trim(),
        catatan: String(base?.catatan ?? ""),
        place: String(base?.place || "").trim(),
      };
    });
    setSelectedRepairBanRows(mappedRows);
    if (!eligibleIds.length) {
      showNotif("warning", "Tidak ada ban yang memenuhi kriteria Repair Ban di Gudang.");
      return;
    }
    if (removedCount > 0) {
      showNotif("warning", `${removedCount} ban tidak memenuhi kriteria dan tidak disertakan.`);
    }
    showNotif("success", `${eligibleIds.length} ban dipilih.`);
  };

  const updateRepairBanStatus = (idBan, statusBaru) => {
    const id = Number(idBan || 0);
    if (!id) return;
    const val = String(statusBaru || "").trim();
    setSelectedRepairBanRows((prev) => prev.map((row) => (
      Number(row?.id_ban || 0) === id ? { ...row, status_after: val } : row
    )));
  };

  useEffect(() => {
    if (activeAction !== "laporan_khusus") return;
    loadTopikLaporanKhusus();
  }, [activeAction, resendToken]);

  useEffect(() => {
    if (isPusat) return;
    if (!kodeCabangUser) return;
    setForm((prev) => ({ ...prev, kodeCabang: kodeCabangUser }));
    setRepairForm((prev) => ({ ...prev, kodeCabang: kodeCabangUser }));
  }, [isPusat, kodeCabangUser]);

  useEffect(() => {
    if (activeAction !== "repair_ban") return;
    const loadTambalOpsiTambahan = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_EVENT_CABANG_TAMBAL_OPSI,
          reason: "refresh opsi tambahan tambal repair gudang",
        });
        const { data } = await api.get(`${backendPort}/api/main/load_opsi_tambahan_tambal`, {
          requestGroup: REQ_GROUP_EVENT_CABANG_TAMBAL_OPSI,
          timeout: 30000,
        });
        setOpsiJenisTambal(Array.isArray(data?.opsiJenisTambal) ? data.opsiJenisTambal : []);
        setOpsiBahanTambal(Array.isArray(data?.opsiBahanTambal) ? data.opsiBahanTambal : []);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error("Gagal memuat opsi tambahan tambal repair gudang:", err);
        setOpsiJenisTambal([]);
        setOpsiBahanTambal([]);
      }
    };
    loadTambalOpsiTambahan();
  }, [activeAction]);

  useEffect(() => {
    if (activeAction === "repair_ban") return;
    setShowTambalDetailModal(false);
    setActiveTambalDetailBanId(0);
  }, [activeAction]);

  useEffect(() => {
    if (activeAction !== "laporan_khusus") return;
    const kodeCabang = String(form?.kodeCabang || "").trim();
    const tanggal = String(form?.tanggal || "").trim();
    loadNomorLaporan(kodeCabang, tanggal);
  }, [activeAction, form?.kodeCabang, form?.tanggal]);

  useEffect(() => {
    if (activeAction !== "repair_ban") return;
    const kodeCabang = String(repairForm?.kodeCabang || "").trim();
    const tanggal = String(repairForm?.tanggal || "").trim();
    loadNomorRepair(kodeCabang, tanggal);
  }, [activeAction, repairForm?.kodeCabang, repairForm?.tanggal]);

  useEffect(() => {
    if (activeAction !== "laporan_khusus") return;
    setForm((prev) => ({
      ...prev,
      idMt: "",
      nopolMt: "",
      idBan: "",
      seriBan: "",
    }));
    setLaporanKhususItems([]);
    setAttachmentsLaporanKhusus([]);
    setTindakLanjutScope("cabang");
    setTindakLanjutRows([]);
    setSelectedTindakLanjutNomor("");
    setSelectedTindakLanjutRow(null);
    setTindakLanjutHistoryRows([]);
  }, [activeAction, form?.kodeCabang]);

  useEffect(() => {
    if (activeAction !== "repair_ban") return;
    setRepairForm((prev) => ({
      ...prev,
    }));
    setSelectedRepairBanRows([]);
    setSelectedRepairBanIds([]);
    setAttachmentsRepairBan([]);
    setShowTambalDetailModal(false);
    setActiveTambalDetailBanId(0);
  }, [activeAction, repairForm?.kodeCabang]);

  const handlePilihTopik = (value) => {
    const val = String(value || "").trim();
    if (val === TOPIK_KEJADIAN_LAIN) {
      setTopikBaru("");
      setShowTopikModal(true);
      return;
    }
    setForm((prev) => ({ ...prev, topik: val }));
  };

  const handleSimpanTopikBaru = () => {
    const val = String(topikBaru || "").trim();
    if (!val) {
      showNotif("error", "Topik kejadian lain wajib diisi.");
      return;
    }
    setOpsiTopikDinamis((prev) => Array.from(new Set([...prev, val])));
    setForm((prev) => ({ ...prev, topik: val }));
    setTopikBaru("");
    setShowTopikModal(false);
  };

  const upsertLaporanKhususItem = (nextItem) => {
    const itemType = String(nextItem?.type || "").trim();
    if (!itemType) return;
    const itemId = itemType === "mt"
      ? String(nextItem?.id_mt || "").trim()
      : String(nextItem?.id_ban || "").trim();
    if (!itemId) return;
    setLaporanKhususItems((prev) => {
      const current = Array.isArray(prev) ? prev : [];
      const idx = current.findIndex((item) => {
        if (String(item?.type || "").trim() !== itemType) return false;
        const existingId = itemType === "mt"
          ? String(item?.id_mt || "").trim()
          : String(item?.id_ban || "").trim();
        return existingId === itemId;
      });
      const nextStatus = String(nextItem?.status_topik || "").trim().toLowerCase();
      const normalizedNextStatus = nextStatus === "done" || nextStatus === "notdone"
        ? nextStatus
        : "notdone";
      if (idx < 0) return [...current, { ...nextItem, status_topik: normalizedNextStatus }];
      return current.map((item, itemIndex) => {
        if (itemIndex !== idx) return item;
        const currentStatus = String(item?.status_topik || "").trim().toLowerCase();
        return {
          ...item,
          ...nextItem,
          status_topik: nextStatus
            ? normalizedNextStatus
            : (currentStatus === "done" || currentStatus === "notdone" ? currentStatus : "notdone"),
        };
      });
    });
  };

  const updateLaporanKhususItemStatus = (itemKey, statusTopik) => {
    const key = String(itemKey || "").trim();
    const status = String(statusTopik || "").trim().toLowerCase();
    if (!key || (status !== "done" && status !== "notdone")) return;
    setLaporanKhususItems((prev) => (Array.isArray(prev) ? prev : []).map((item) => (
      String(item?.key || "").trim() === key
        ? { ...item, status_topik: status }
        : item
    )));
  };

  const updateLaporanKhususItemUraian = (itemKey, uraian) => {
    const key = String(itemKey || "").trim();
    if (!key) return;
    setLaporanKhususItems((prev) => (Array.isArray(prev) ? prev : []).map((item) => (
      String(item?.key || "").trim() === key
        ? { ...item, uraian: String(uraian || "").slice(0, 500) }
        : item
    )));
  };

  const updateLaporanKhususItemAttachments = (itemKey, nextAttachments) => {
    const key = String(itemKey || "").trim();
    if (!key) return;
    setLaporanKhususItems((prev) => (Array.isArray(prev) ? prev : []).map((item) => {
      if (String(item?.key || "").trim() !== key) return item;
      const currentAttachments = Array.isArray(item?.attachments) ? item.attachments : [];
      const resolved = typeof nextAttachments === "function"
        ? nextAttachments(currentAttachments)
        : nextAttachments;
      const resolvedAttachments = Array.isArray(resolved) ? resolved : [];
      const invalidIndexes = resolvedAttachments
        .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
        .filter((idx) => idx >= 0);
      setInvalidCaptionIndexesByItemKey((prevMap) => ({
        ...(prevMap || {}),
        [key]: invalidIndexes,
      }));
      return {
        ...item,
        attachments: resolvedAttachments,
      };
    }));
  };

  const removeLaporanKhususItem = (itemKey) => {
    const key = String(itemKey || "").trim();
    if (!key) return;
    setLaporanKhususItems((prev) => (Array.isArray(prev) ? prev : []).filter(
      (item) => String(item?.key || "").trim() !== key
    ));
    setInvalidCaptionIndexesByItemKey((prevMap) => {
      const next = { ...(prevMap || {}) };
      delete next[key];
      return next;
    });
  };
  const tindakLanjutLampiranFiles = useMemo(() => {
    const lampiran = Array.isArray(activeLampiranHistoryRow?.lampiran) ? activeLampiranHistoryRow.lampiran : [];
    return lampiran
      .map((item, idx) => {
        const pathRaw = String(item?.path || "").trim();
        const fileRaw = String(item?.file || "").trim();
        let url = "";
        if (pathRaw) {
          url = pathRaw.startsWith("http") ? pathRaw : `${backendPort}${pathRaw}`;
        } else if (fileRaw) {
          url = `${backendPort}/uploads/dokumen/${fileRaw}`;
        }
        return {
          url,
          name: String(item?.name || fileRaw || `Lampiran ${idx + 1}`).trim(),
          caption: String(item?.caption || "").trim(),
        };
      })
      .filter((item) => Boolean(String(item?.url || "").trim()));
  }, [activeLampiranHistoryRow]);

  const openDetailMtFromForm = () => {
    const idMt = String(form?.idMt || "").trim();
    if (!idMt) return;
    const row = mtDetailMap?.[idMt] || selectedMt || {};
    setSelectedMtDetail({
      id_mt: row?.id_mt || idMt,
      nopol: row?.nopol || form?.nopolMt || "-",
      kode_cabang: row?.kode_cabang || form?.kodeCabang || (!isPusat ? kodeCabangUser : ""),
      merk: row?.merk || "-",
      kapasitas: row?.kapasitas || "-",
      kategori: row?.kategori || "-",
      status: row?.status || "-",
      roda: Number(row?.roda || mtProfilMap?.[idMt]?.roda || selectedMt?.roda || 0),
      cadangan: Number(row?.cadangan || mtProfilMap?.[idMt]?.cadangan || selectedMt?.cadangan || 0),
      tahun_pembuatan: row?.tahun_pembuatan || "",
      kir: row?.kir || "",
      odo_awal: row?.odo_awal || 0,
      catatan_mt: row?.catatan_mt || "",
      tanggal: row?.tanggal || "",
      user: row?.user || namaUser || "",
      lampiran: Array.isArray(row?.lampiran) ? row.lampiran : [],
      lampiran_mt_event: row?.lampiran_mt_event || "",
    });
    setShowDetailMtPage(true);
  };

  const handleSubmitLaporanKhusus = async () => {
    if (isSubmitting) return;
    const kodeCabang = String(form?.kodeCabang || "").trim();
    if (!kodeCabang || !idUserAktif || !namaUser || !usernameUser) {
      showNotif("error", "Data user aktif belum valid.");
      return;
    }

    const nomor = String(form?.nomor || "").trim();
    const kategori = String(form?.kategori || "").trim();
    const topik = String(form?.topik || "").trim();
    const namaPemeriksa = String(form?.namaPemeriksa || "").trim();
    const isTindakLanjut = kategori === KATEGORI_TINDAK_LANJUT;
    if (!kodeCabang || !kategori || !nomor || (!isTindakLanjut && !topik)) {
      showNotif("error", "Data laporan khusus belum lengkap.");
      return;
    }
    if (!namaPemeriksa) {
      showNotif("error", "Nama user pemeriksa wajib diisi.");
      return;
    }

    try {
      setIsSubmitting(true);
      if (isTindakLanjut) {
        if (!selectedTindakLanjutRow?.id) {
          showNotif("error", "Pilih laporan yang akan ditindaklanjuti.");
          return;
        }
        const uraianTl = String(form?.uraian || "").trim();
        if (!uraianTl) {
          showNotif("error", "Uraian kondisi tindak lanjut wajib diisi.");
          return;
        }
        if (uraianTl.length > 500) {
          showNotif("error", "Uraian kondisi maksimal 500 karakter.");
          return;
        }
        const statusTindakLanjut = String(form?.status_tindak_lanjut || "notdone").trim().toLowerCase();
        if (statusTindakLanjut !== "done" && statusTindakLanjut !== "notdone") {
          showNotif("error", "Status tindak lanjut tidak valid.");
          return;
        }
        if (statusTindakLanjut === "done" && !canCloseTindakLanjut) {
          showNotif("error", "Hanya cabang pembuat laporan atau Pusat yang dapat menyelesaikan laporan.");
          return;
        }
        const invalidTlCaptions = (Array.isArray(attachmentsLaporanKhusus) ? attachmentsLaporanKhusus : [])
          .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
          .filter((idx) => idx >= 0);
        if (invalidTlCaptions.length > 0) {
          setInvalidCaptionIndexesLaporanKhusus(invalidTlCaptions);
          showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
          return;
        }
        const formDataTl = new FormData();
        const jenisLaporanTl = isMtIdentity(selectedTindakLanjutRow?.identity) ? "Laporan MT" : "Laporan Ban";
        formDataTl.append("kode_cabang", kodeCabangUser);
        formDataTl.append("nomor", nomor);
        formDataTl.append("tanggal", String(form?.tanggal || buildTodayKey()));
        formDataTl.append("kategori", KATEGORI_TINDAK_LANJUT);
        formDataTl.append("topik", String(selectedTindakLanjutRow?.topik || topik));
        formDataTl.append("jenis_laporan", jenisLaporanTl);
        formDataTl.append("id_mt", String(selectedTindakLanjutRow?.id_mt || ""));
        formDataTl.append("id_ban", String(selectedTindakLanjutRow?.id_ban || ""));
        formDataTl.append("uraian", uraianTl);
        formDataTl.append("id_tindak_lanjut", String(selectedTindakLanjutRow?.id || ""));
        formDataTl.append("status_tindak_lanjut", statusTindakLanjut);
        formDataTl.append("check_validasi", "true");
        formDataTl.append("id_user", String(idUserAktif));
        formDataTl.append("kode_cabang_user", kodeCabangUser);
        formDataTl.append("nama_user", namaUser);
        formDataTl.append("username_user", usernameUser);
        formDataTl.append("nama_pemeriksa", String(form?.namaPemeriksa || "").trim());
        (Array.isArray(attachmentsLaporanKhusus) ? attachmentsLaporanKhusus : []).forEach((item) => {
          if (item?.file instanceof File) {
            formDataTl.append("files", item.file);
            formDataTl.append("captions", String(item?.caption || ""));
          }
        });
        api.cancelPendingRequests({ group: REQ_GROUP_EVENT_CABANG_SUBMIT_LK, reason: "Submit laporan khusus terbaru" });
        const { data } = await api.post(`${backendPort}/api/main/submit_laporan_khusus_cabang`, formDataTl, {
          requestGroup: REQ_GROUP_EVENT_CABANG_SUBMIT_LK,
          timeout: 120000,
        });
        showNotif("success", data?.message || "Tindak lanjut laporan berhasil disimpan.");
      } else {
        const kategoriSubmit = kategori === "Perlu Tindak Lanjut" ? "Perlu Tindak Lanjut" : kategori;
        const itemCandidates = (Array.isArray(laporanKhususItemsAktif) ? laporanKhususItemsAktif : [])
          .filter((item) => {
            const type = String(item?.type || "").trim();
            if (type === "mt") return Boolean(String(item?.id_mt || "").trim());
            if (type === "ban") return Boolean(String(item?.id_ban || "").trim());
            return false;
          });
        if (!itemCandidates.length) {
          showNotif("error", "Tambahkan minimal 1 item MT/Ban terlebih dahulu.");
          return;
        }
        const invalidStatusItem = itemCandidates.find((item) => {
          const status = String(item?.status_topik || "").trim().toLowerCase();
          return status !== "done" && status !== "notdone";
        });
        if (invalidStatusItem) {
          showNotif("error", "Status laporan setiap item wajib dipilih.");
          return;
        }
        const invalidCaptionMap = {};
        itemCandidates.forEach((item) => {
          const key = String(item?.key || "").trim();
          if (!key) return;
          const invalidIndexes = (Array.isArray(item?.attachments) ? item.attachments : [])
            .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
            .filter((idx) => idx >= 0);
          if (invalidIndexes.length > 0) invalidCaptionMap[key] = invalidIndexes;
        });
        if (Object.keys(invalidCaptionMap).length > 0) {
          setInvalidCaptionIndexesByItemKey(invalidCaptionMap);
          showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
          return;
        }

        api.cancelPendingRequests({ group: REQ_GROUP_EVENT_CABANG_SUBMIT_LK, reason: "Submit laporan khusus terbaru" });
        let insertedCount = 0;
        for (const item of itemCandidates) {
          const selectedType = String(item?.type || "").trim();
          const jenisLaporan = selectedType === "ban" ? "Laporan Ban" : "Laporan MT";
          const idMt = selectedType === "mt" ? String(item?.id_mt || "").trim() : "";
          const idBan = selectedType === "ban" ? String(item?.id_ban || "").trim() : "";
          const uraian = String(item?.uraian || "").trim();
          const statusTopik = String(item?.status_topik || "").trim().toLowerCase();
          if (!uraian) {
            throw new Error(`Uraian kondisi untuk ${selectedType === "ban" ? `Ban ${idBan}` : `MT ${idMt}`} wajib diisi.`);
          }
          if (uraian.length > 500) {
            throw new Error(`Uraian kondisi untuk ${selectedType === "ban" ? `Ban ${idBan}` : `MT ${idMt}`} maksimal 500 karakter.`);
          }
          const formData = new FormData();
          formData.append("kode_cabang", kodeCabang);
          formData.append("nomor", nomor);
          formData.append("tanggal", String(form?.tanggal || buildTodayKey()));
          formData.append("kategori", kategoriSubmit);
          formData.append("topik", topik);
          formData.append("jenis_laporan", jenisLaporan);
          formData.append("id_mt", idMt);
          formData.append("id_ban", idBan);
          formData.append("uraian", uraian);
          formData.append("status_topik", statusTopik);
          formData.append("check_validasi", "true");
          formData.append("id_user", String(idUserAktif));
          formData.append("kode_cabang_user", kodeCabangUser);
          formData.append("nama_user", namaUser);
          formData.append("username_user", usernameUser);
          formData.append("nama_pemeriksa", String(form?.namaPemeriksa || "").trim());
          (Array.isArray(item?.attachments) ? item.attachments : []).forEach((att) => {
            if (att?.file instanceof File) {
              formData.append("files", att.file);
              formData.append("captions", String(att?.caption || ""));
            }
          });
          await api.post(`${backendPort}/api/main/submit_laporan_khusus_cabang`, formData, {
            timeout: 120000,
          });
          insertedCount += 1;
        }
        showNotif("success", `${insertedCount} laporan khusus berhasil disimpan.`);
      }
      resetFormLaporan();
      await loadTopikLaporanKhusus();
      await loadNomorLaporan(kodeCabang, buildTodayKey());
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal menyimpan laporan khusus.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmitRepairBan = async () => {
    if (isSubmittingRepair) return;
    const kodeCabang = String(repairForm?.kodeCabang || "").trim();
    const tanggal = String(repairForm?.tanggal || "").trim();
    const namaPemeriksa = String(repairForm?.namaPemeriksa || "").trim();
    const selectedRows = Array.isArray(selectedRepairBanRows) ? selectedRepairBanRows : [];
    if (!kodeCabang || !tanggal) {
      showNotif("error", "Lengkapi cabang dan tanggal.");
      return;
    }
    if (!selectedRows.length) {
      showNotif("error", "Pilih ban terlebih dahulu.");
      return;
    }
    const invalidQtyRow = selectedRows.find((row) => {
      const qtyVal = Number(row?.qty_tambal);
      return !Number.isFinite(qtyVal) || qtyVal < 0 || qtyVal > 4;
    });
    if (invalidQtyRow) {
      showNotif("error", `Quantity tambal id_ban ${invalidQtyRow.id_ban} harus 0 sampai 4.`);
      return;
    }
    const invalidStatusRow = selectedRows.find((row) => !String(row?.status_after || "").trim());
    if (invalidStatusRow) {
      showNotif("error", `Status baru id_ban ${invalidStatusRow.id_ban} belum dipilih.`);
      return;
    }
    const invalidJenisRow = selectedRows.find((row) => !String(row?.jenis_tambal || "").trim());
    if (invalidJenisRow) {
      showNotif("error", `Jenis tambal id_ban ${invalidJenisRow.id_ban} wajib dipilih.`);
      return;
    }
    if (!namaPemeriksa) {
      showNotif("error", "Nama user pemeriksa wajib diisi.");
      return;
    }
    const invalidRepairCaptions = (Array.isArray(attachmentsRepairBan) ? attachmentsRepairBan : [])
      .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0);
    if (invalidRepairCaptions.length > 0) {
      setInvalidCaptionIndexesRepairBan(invalidRepairCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }

    try {
      setIsSubmittingRepair(true);
      const rowsPayload = selectedRows.map((row) => ({
        id_ban: Number(row?.id_ban || 0),
        qty_tambal: Number(row?.qty_tambal || 0),
        jenis_tambal: String(row?.jenis_tambal || "").trim(),
        bahan_tambal: String(row?.bahan_tambal || "").trim(),
        catatan: String(row?.catatan ?? ""),
        status_lama: String(row?.status_before || "").trim(),
        status_baru: String(row?.status_after || "").trim(),
      })).filter((row) => Number.isFinite(row.id_ban) && row.id_ban > 0);
      const formData = new FormData();
      formData.append("tanggal", tanggal);
      formData.append("kode_cabang", kodeCabang);
      formData.append("rows", JSON.stringify(rowsPayload));
      formData.append("user", namaUser);
      (Array.isArray(attachmentsRepairBan) ? attachmentsRepairBan : []).forEach((item) => {
        if (item?.file instanceof File) {
          formData.append("files", item.file);
        }
        formData.append("captions", String(item?.caption || ""));
      });
      const existingLampiran = (Array.isArray(attachmentsRepairBan) ? attachmentsRepairBan : [])
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: String(item?.name || "").trim(),
          file: String(item?.db_file || item?.file || "").trim(),
          path: String(item?.path || "").trim(),
          type: String(item?.type || "").trim(),
          size: Number(item?.size || 0),
          caption: String(item?.caption || "").trim(),
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      api.cancelPendingRequests({ group: REQ_GROUP_EVENT_CABANG_SUBMIT_REPAIR, reason: "Submit repair terbaru" });
      const { data } = await api.post(
        `${backendPort}/api/main/submit_tambal_di_gudang`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          requestGroup: REQ_GROUP_EVENT_CABANG_SUBMIT_REPAIR,
          timeout: 120000,
        }
      );
      showNotif("success", data?.message || "Repair ban berhasil disimpan.");
      setRepairForm((prev) => ({
        ...prev,
        checkValidasi: false,
        namaPemeriksa: namaUser,
      }));
      setSelectedRepairBanRows([]);
      setSelectedRepairBanIds([]);
      setAttachmentsRepairBan([]);
      setInvalidCaptionIndexesRepairBan([]);
      await loadNomorRepair(kodeCabang, tanggal);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit repair ban.");
    } finally {
      setIsSubmittingRepair(false);
    }
  };

  return (
    <div className="container-fluid px-0 page30-table-theme page16-wo2-table-theme page16-wo-elegant-theme">
      <div className="page16-header d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
        <div>
          <h3 className="page16-title">Event Lain</h3>
        </div>
      </div>
      <div className="row g-3">
        <div className="col-12 col-md-4">
          <div className="page16-action-grid">
            <div className="row g-2">
              {EVENT_CABANG_ACTIONS.map((action) => (
                <div key={action.value} className="col-12">
                  <button
                    type="button"
                    className={`page15-odotd-action ${activeAction === action.value ? "is-active" : ""}`}
                    onClick={() => setActiveAction(action.value)}
                  >
                    <div className="d-flex justify-content-between align-items-start gap-2">
                      <div>
                        <h5 className="mb-1 text-white">{action.title}</h5>
                        <p className="mb-0 text-white-80 small">{action.description}</p>
                      </div>
                      <span className="page16-action-state text-white">
                        {activeAction === action.value ? "Aktif" : "Pilih"}
                      </span>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-12 col-md-8">
          <div className={activeAction ? "page16-panel-form panel-accent-default h-100" : ""}>
            {!activeAction && (
              <div className="page16-panel-placeholder d-flex flex-column justify-content-center align-items-center text-center h-100">
                <p className="fw-semibold mb-1">Belum ada menu dipilih.</p>
                <p className="text-muted small mb-0">Klik salah satu menu di sebelah kiri untuk membuka panel.</p>
              </div>
            )}

            {activeAction === "laporan_khusus" && (
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                  <div>
                    <p className="page16-panel-label mb-1">Action</p>
                    <h4 className="page16-panel-title mb-1">LAPORAN KHUSUS</h4>
                    <p className="text-muted small mb-0">Catat kondisi khusus cabang secara terstruktur.</p>
                  </div>
                  <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveAction("")}> 
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>

                <div className="row g-3">
                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-3 align-items-end">
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Cabang</label>
                            {isPusat ? (
                              <select
                                className={`form-select ${invalidLaporanCabang ? "field-required-invalid" : ""}`}
                                value={form.kodeCabang}
                                onChange={(e) => setForm((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                              >
                                <option value="">Pilih Cabang</option>
                                {opsiCabang.map((x) => (
                                  <option key={`lk-cbg-${x.kode_cabang}`} value={x.kode_cabang}>
                                    {x.nama_cabang}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                className="form-control"
                                readOnly
                                value={namaCabangByKode.get(kodeCabangUser) || kodeCabangUser || "-"}
                              />
                            )}
                          </div>
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Nomor Laporan</label>
                            <input className="form-control" readOnly value={form.nomor || "-"} />
                          </div>
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Tanggal Input</label>
                            <input
                              type="date"
                              className="form-control"
                              value={form.tanggal}
                              onChange={(e) => setForm((prev) => ({ ...prev, tanggal: e.target.value }))}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Kategori</label>
                            <select
                              className={`form-select ${invalidLaporanKategori ? "field-required-invalid" : ""}`}
                              value={form.kategori}
                              onChange={(e) => handleKategoriLaporanChange(e.target.value)}
                            >
                              <option value="">Pilih Kategori</option>
                              {KATEGORI_OPSI.map((item) => (
                                <option key={`kat-${item}`} value={item}>{item}</option>
                              ))}
                            </select>
                          </div>
                          {!isKategoriTindakLanjut && (
                            <div className="col-12 col-lg-8">
                              <label className="form-label">Topik</label>
                              <select className={`form-select ${invalidLaporanTopik ? "field-required-invalid" : ""}`} value={form.topik} onChange={(e) => handlePilihTopik(e.target.value)}>
                                <option value="">Pilih Topik</option>
                                {opsiTopik.map((item) => (
                                  <option key={`topik-${item}`} value={item}>{item}</option>
                                ))}
                                <option value={TOPIK_KEJADIAN_LAIN} style={{ color: "#0d6efd", fontWeight: 600 }}>Topik Lain...</option>
                              </select>
                            </div>
                          )}
                          <div className="col-12">
                              <div className="row g-3">
                                {!isKategoriTindakLanjut && (
                                  <>
                                    <div className="col-12 col-lg-4">
                                      <label className="form-label">MT Terkait</label>
                                      <div className="input-group">
                                        <button
                                          type="button"
                                          className={`btn btn-primary ${!isPickerLaporanReady ? "field-required-invalid-btn" : ""}`}
                                          disabled={!isPickerLaporanReady}
                                          onClick={() => setShowCariMt(true)}
                                        >
                                          Pilih MT
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-12 col-lg-4">
                                      <label className="form-label">Ban Terkait</label>
                                      <div className="input-group">
                                        <button
                                          type="button"
                                          className={`btn btn-primary ${!isPickerLaporanReady ? "field-required-invalid-btn" : ""}`}
                                          disabled={!isPickerLaporanReady}
                                          onClick={() => setShowCariBan(true)}
                                        >
                                          Pilih Ban
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row g-3 mt-0">
                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        {!isKategoriTindakLanjut && (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="fw-semibold">
                                Daftar Item Terpilih
                              </span>
                              <small className="text-muted">
                                {`${laporanKhususItemsAktif.length} item`}
                              </small>
                            </div>
                            <div className={`border rounded p-2 ${invalidLaporanItemKosong ? "field-required-invalid" : ""}`}>
                              {laporanKhususItemsAktif.length === 0 && (
                                <div className="px-3 py-4 text-center text-muted small">
                                  Belum ada item terpilih.
                                </div>
                              )}
                              {laporanKhususItemsAktif.map((item) => (
                                <div key={item.key} className="border rounded p-2 mb-2">
                                  <div className="row g-2 mb-2 align-items-start">
                                    <div className="col-12 col-lg-3">
                                      <div className="small text-muted">
                                        {item?.type === "mt" ? "No.Pol" : "No.Seri"}
                                      </div>
                                      <div className="fw-semibold">
                                        {item?.type === "mt"
                                          ? String(item?.nopol || "-")
                                          : String(item?.seri_ban || "-")}
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                      <div className="small text-muted">
                                        {item?.type === "mt" ? "ID MT" : "ID Ban"}
                                      </div>
                                      <div className="fw-semibold">
                                        {item?.type === "mt"
                                          ? String(item?.id_mt || "-")
                                          : String(item?.id_ban || "-")}
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-3">
                                      <div className="small text-muted">Jenis</div>
                                      <div className="fw-semibold">
                                        {item?.type === "mt" ? "Laporan MT" : "Laporan Ban"}
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-3 d-flex justify-content-lg-end">
                                      <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => removeLaporanKhususItem(item.key)}
                                      >
                                        <i className="fa fa-trash" aria-hidden="true" />
                                      </button>
                                    </div>
                                  </div>

                                  <div className="row g-3">
                                    <div className="col-12 col-lg-8">
                                      <label className="form-label small text-muted mb-1">Uraian Kondisi</label>
                                      <textarea
                                        className={`form-control form-control-sm ${isLaporanItemUraianInvalid(item) ? "field-required-invalid" : ""}`}
                                        rows={3}
                                        maxLength={500}
                                        value={String(item?.uraian || "")}
                                        onChange={(e) => updateLaporanKhususItemUraian(item.key, e.target.value)}
                                        placeholder="Uraian kondisi (maks. 500)"
                                      />
                                      <small className="text-muted">{`${String(item?.uraian || "").length}/500`}</small>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                      <label className="form-label small text-muted mb-1">Status</label>
                                      <select
                                        className={`form-select form-select-sm ${isLaporanItemStatusInvalid(item) ? "field-required-invalid" : ""}`}
                                        value={String(item?.status_topik || "notdone")}
                                        onChange={(e) => updateLaporanKhususItemStatus(item.key, e.target.value)}
                                      >
                                        <option value="notdone">Perlu Tindak Lanjut</option>
                                        <option value="done">Selesai</option>
                                      </select>
                                    </div>
                                    <div className="col-12">
                                      <label className="form-label small text-muted mb-1">Upload Dokumen</label>
                                      <PageKonten9_Pict
                                        attachments={Array.isArray(item?.attachments) ? item.attachments : []}
                                        setAttachments={(nextAttachments) => updateLaporanKhususItemAttachments(item.key, nextAttachments)}
                                        bisaInput={true}
                                        invalidCaptionIndexes={Array.isArray(invalidCaptionIndexesByItemKey?.[String(item?.key || "")])
                                          ? invalidCaptionIndexesByItemKey[String(item?.key || "")]
                                          : []}
                                        onCaptionChange={() => {
                                          const key = String(item?.key || "").trim();
                                          if (!key) return;
                                          setInvalidCaptionIndexesByItemKey((prevMap) => ({
                                            ...(prevMap || {}),
                                            [key]: [],
                                          }));
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {isKategoriTindakLanjut && (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="fw-semibold">Laporan Sebelumnya</span>
	                              <button type="button" className={`btn btn-sm btn-outline-primary ${invalidTindakLanjutSelection ? "field-required-invalid-btn" : ""}`} onClick={() => openTindakLanjutPicker()}>
	                                Pilih Laporan
	                              </button>
                            </div>
                            {!selectedTindakLanjutRow && (
	                              <div className={`border rounded px-3 py-4 text-center text-muted small ${invalidTindakLanjutSelection ? "field-required-invalid" : ""}`}>
	                                Belum ada laporan yang dipilih untuk ditindaklanjuti.
	                              </div>
                            )}
                            {selectedTindakLanjutRow && (
                              <>
                                {(Array.isArray(tindakLanjutHistoryRows) && tindakLanjutHistoryRows.length > 0
                                  ? tindakLanjutHistoryRows
                                  : [selectedTindakLanjutRow]).map((hist, idx) => (
                                  <div key={`hist-tl-${hist?.id || hist?.nomor || "x"}`} className="border rounded p-2 mb-2">
                                    <div className="row g-2 mb-2">
                                      <div className="col-12 col-lg-3">
                                        <div className="small text-muted">No. Laporan</div>
                                        <div className="fw-semibold">
                                          {`${String(hist?.nomor || "-")} (${formatTanggalLaporan(hist?.tanggal)})`}
                                        </div>
                                      </div>
                                      <div className="col-12 col-lg-3">
                                        <div className="small text-muted">Pelapor</div>
                                        <div className="fw-semibold">
                                          {`${String(
                                            namaCabangByKode.get(String(hist?.kode_cabang || "").trim())
                                            || hist?.kode_cabang
                                            || "-"
                                          )} (${String(hist?.user || "-")})`}
                                        </div>
                                      </div>
                                      {idx === 0 && (
                                        <>
                                          <div className="col-12 col-lg-3">
                                            <div className="small text-muted">No.Pol / No.Seri</div>
                                            <div className="fw-semibold">{resolveLaporanIdentityLabel(hist)}</div>
                                          </div>
                                          <div className="col-12 col-lg-3">
                                            <div className="small text-muted">Topik</div>
                                            <div className="fw-semibold">{String(hist?.topik || "-")}</div>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    <div className="row g-3">
                                      <div className="col-12 col-lg-9">
	                                        <textarea
	                                          className="form-control"
	                                          rows={2}
	                                          readOnly
	                                          value={String(hist?.uraian || "")}
	                                          style={{ height: "auto", minHeight: "50px" }}
                                        />
                                      </div>
                                      <div className="col-12 col-lg-3">
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary w-100"
                                          disabled={!(Array.isArray(hist?.lampiran) && hist.lampiran.length > 0)}
                                          onClick={() => {
                                            setActiveLampiranHistoryRow(hist);
                                            setShowLampiranTindakLanjut(true);
                                          }}
                                        >
                                          Lampiran ({Array.isArray(hist?.lampiran) ? hist.lampiran.length : 0})
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                          </>
                        )}
                      </div>
                       
                    </div>
                  </div>
                   {isKategoriTindakLanjut && selectedTindakLanjutRow && (
                      <div className="col-12">
                    <div className="card page16-verify-card page16-soft-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="fw-semibold">{`Laporan Terbaru tgl ${formatTanggalLaporan(form?.tanggal)}`}</span>
                            </div>
                        <div className="row g-3 mt-3">
                                  <div className="col-12 col-lg-9">
	                                    <textarea
	                                      className={`form-control ${invalidTindakLanjutUraian ? "field-required-invalid" : ""}`}
	                                      rows={2}
                                      maxLength={500}
                                      value={String(form?.uraian || "")}
                                      onChange={(e) => setForm((prev) => ({ ...prev, uraian: e.target.value }))}
                                      placeholder="Input hasil tindak lanjut"
                                    />
                                    <small className="text-muted">{`${String(form?.uraian || "").length}/500`}</small>
                                  </div>
                                  <div className="col-12 col-lg-3">
                                    <select
                                      className="form-select"
                                      value={String(form?.status_tindak_lanjut || "notdone")}
                                      onChange={(e) => {
                                        const nextStatus = e.target.value;
                                        if (nextStatus === "done" && !canCloseTindakLanjut) return;
                                        setForm((prev) => ({ ...prev, status_tindak_lanjut: nextStatus }));
                                      }}
                                    >
                                      <option value="notdone">Belum Selesai</option>
                                      <option value="done" disabled={!canCloseTindakLanjut}>Selesai</option>
                                    </select>
                                    {!canCloseTindakLanjut && (
                                      <small className="text-muted">
                                        Status Selesai hanya dapat dipilih oleh cabang pembuat laporan atau Pusat.
                                      </small>
                                    )}
                                  </div>
                                </div>
                            </div>
                        <div className="row g-3 justify-content-center mx-2">    
                        <div className="col-12 col-lg-8">
                          <label className="form-label">Upload Dokumen</label>
                          <PageKonten9_Pict
                            attachments={attachmentsLaporanKhusus}
                            setAttachments={setAttachmentsLaporanKhusus}
                            bisaInput={true}
                            invalidCaptionIndexes={invalidCaptionIndexesLaporanKhusus}
                            onCaptionChange={() => setInvalidCaptionIndexesLaporanKhusus([])}
                          />
                          </div>
                        </div>
                      </div>
                    </div>      
                   )}
                  <div className="col-12">
                    <div className="card page16-verify-card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-2 align-items-center">
                          <div className="col-12 col-md-8">
                            <span className="fw-semibold">Petugas Input</span>
                          </div>
                          <div className="col-12 col-md-4 ms-md-auto">
	                            <input
	                              type="text"
	                              className={`form-control ${invalidLaporanPetugas ? "field-required-invalid" : ""}`}
	                              value={form?.namaPemeriksa || ""}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
	                  <button
	                    type="button"
	                    className={`btn btn-primary ${!isLaporanKhususSubmitReady ? "field-required-invalid-btn" : ""}`}
	                    disabled={!isHeaderLaporanReady || isSubmitting}
                    onClick={handleSubmitLaporanKhusus}
                  >
                    {isSubmitting ? "Menyimpan..." : "Submit"}
                  </button>
                </div>
              </div>
            )}

            {activeAction === "repair_ban" && (
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                  <div>
                    <p className="page16-panel-label mb-1">Action</p>
                    <h4 className="page16-panel-title mb-1">REPAIR BAN DI GUDANG</h4>
                    <p className="text-muted small mb-0">Input aktivitas repair/tambal ban gudang cabang.</p>
                  </div>
                  <button type="button" className="btn btn-sm btn-outline-secondary page16-panel-close" onClick={() => setActiveAction("")}>
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>
                <div className="row g-3">
                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Cabang</label>
                            {isPusat ? (
                              <select
                                className={`form-select ${invalidRepairCabang ? "field-required-invalid" : ""}`}
                                value={repairForm.kodeCabang}
                                onChange={(e) => setRepairForm((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                              >
                                <option value="">Pilih Cabang</option>
                                {opsiCabang.map((x) => (
                                  <option key={`repair-cbg-${x.kode_cabang}`} value={x.kode_cabang}>
                                    {x.nama_cabang}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input className="form-control" readOnly value={namaCabangByKode.get(kodeCabangUser) || kodeCabangUser || "-"} />
                            )}
                          </div>
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Nomor Transaksi (Perkiraan)</label>
                            <input className="form-control" readOnly value={repairForm.nomor || "-"} />
                          </div>
                          <div className="col-12 col-lg-4">
                            <label className="form-label">Tanggal Input</label>
                            <input
                              type="date"
                              className="form-control"
                              value={repairForm.tanggal}
                              onChange={(e) => setRepairForm((prev) => ({ ...prev, tanggal: e.target.value }))}
                              readOnly
                            />
                          </div>
                          <div className="col-12 col-lg-4">
                            <div>
	                              <button
	                                type="button"
	                                className={`btn btn-outline-primary ${invalidRepairBanSelection ? "field-required-invalid-btn" : ""}`}
	                                disabled={!repairForm.kodeCabang}
	                                onClick={handleOpenPilihBanRepair}
	                              >
                                Pilih Ban
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="fw-semibold">Daftar Ban Repair/Tambal</div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-sm table-hover align-middle">
                            <thead>
                              <tr>
                                <th>id_ban</th>
                                <th>Seri Ban</th>
                                <th>Status</th>
                                <th style = {{minWidth: "200px"}}>Catatan</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedRepairBanRows.length === 0 && (
                                <tr>
                                  <td colSpan={4} className="text-center text-muted">Belum ada ban dipilih.</td>
                                </tr>
                              )}
                              {selectedRepairBanRows.map((row) => (
                                <tr key={`repair-ban-row-${row.id_ban}`}>
                                  <td>{Number(row?.id_ban || 0)}</td>
                                  <td>{String(row?.seri_ban || "-")}</td>
                                  <td>
	                                    <select
	                                      className={`form-select form-select-sm ${!String(row?.status_after || "").trim() ? "field-required-invalid" : ""}`}
	                                      value={String(row?.status_after || "")}
	                                      onChange={(e) => updateRepairBanStatus(row.id_ban, e.target.value)}
	                                    >
                                      {getRepairStatusOptions(row?.status_before, row?.status_sebelum_perlu_repair).map((opt) => (
                                        <option key={`repair-status-${row.id_ban}-${opt}`} value={opt}>
                                          {opt === "CASING" ? "Casing" : opt}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                  <td>
	                                    <button
	                                      type="button"
	                                      className={`form-control form-control-sm text-start ${isRepairRowDetailInvalid(row) ? "field-required-invalid" : ""}`}
	                                      onClick={() => {
	                                        setActiveTambalDetailBanId(Number(row?.id_ban || 0));
	                                        setShowTambalDetailModal(true);
	                                      }}
	                                    >
                                      {String(row?.catatan || "").trim() || String(row?.jenis_tambal || "").trim() || String(row?.bahan_tambal || "").trim() || "-"}
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="mt-2 small fw-semibold">
                          {`Repair/Tambal Ban gudang sebanyak ${selectedRepairBanRows.length} ban.`}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="card page16-soft-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-center">
                          <span>Upload Dokumen (Jika Diperlukan)</span>
                        </div>
                        <PageKonten9_Pict
                          attachments={attachmentsRepairBan}
                          setAttachments={setAttachmentsRepairBan}
                          bisaInput={true}
                          invalidCaptionIndexes={invalidCaptionIndexesRepairBan}
                          onCaptionChange={() => setInvalidCaptionIndexesRepairBan([])}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="card page16-verify-card page16-soft-card">
                      <div className="card-body">
                        <div className="row g-2 align-items-center">
                          <div className="col-12 col-md-8">
                            <span className="fw-semibold">Petugas Input</span>
                          </div>
                          <div className="col-12 col-md-4 ms-md-auto">
	                            <input className={`form-control ${invalidRepairUser ? "field-required-invalid" : ""}`} value={repairForm.namaPemeriksa} readOnly />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-end">
	                    <button
	                      type="button"
	                      className={`btn btn-primary ${!isRepairSubmitReady ? "field-required-invalid-btn" : ""}`}
	                      disabled={isSubmittingRepair}
                      onClick={handleSubmitRepairBan}
                    >
                      {isSubmittingRepair ? "Menyimpan..." : "Simpan Data Repair"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ModalCariMT
        open={showCariMt}
        onClose={() => setShowCariMt(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || "").trim();
          if (!idMt) {
            setShowCariMt(false);
            return;
          }
          upsertLaporanKhususItem({
            key: `mt-${idMt}`,
            type: "mt",
            id_mt: idMt,
            nopol: String(mt?.nopol || "").trim(),
            uraian: "",
            attachments: [],
          });
          setForm((prev) => ({
            ...prev,
            idMt,
            nopolMt: String(mt?.nopol || "").trim(),
          }));
          setShowCariMt(false);
        }}
        globalOpsi={globalOpsi}
        kodeCabang={form.kodeCabang}
      />
      <ModalCariBanMulti
        open={openRepairBanModal}
        onClose={() => setOpenRepairBanModal(false)}
        onSubmit={handleSelesaiPilihBanRepair}
        showNotif={showNotif}
        globalOpsi={globalOpsi}
        kodeCabang={repairForm.kodeCabang}
        title="Pilih Ban - Repair Ban di Gudang"
        subtitle="Menampilkan ban gudang dengan status NT, UT, VT-*, UV-*, Casing, dan Afkir."
        initialSelectedIds={selectedRepairBanIds}
        initialSelectedRows={selectedRepairBanRows}
        forcedLocationFilters={FORCED_LOCATION_GUDANG_ONLY}
        disableLocationFilterControls={true}
        blockedLocationFilters={BLOCKED_LOCATION_OTF_ONLY}
        enrichFields={["status_sebelum_perlu_repair"]}
      />
      <ModalCariBan
        open={showCariBan}
        onClose={() => setShowCariBan(false)}
        showNotif={showNotif}
        onSelect={(ban) => {
          const idBan = String(ban?.id_ban || "").trim();
          if (!idBan) {
            setShowCariBan(false);
            return;
          }
          upsertLaporanKhususItem({
            key: `ban-${idBan}`,
            type: "ban",
            id_ban: idBan,
            seri_ban: String(ban?.seri_ban || "").trim(),
            uraian: "",
            attachments: [],
          });
          setForm((prev) => ({ ...prev, idBan, seriBan: String(ban?.seri_ban || "") }));
          setShowCariBan(false);
        }}
        globalOpsi={globalOpsi}
        kodeCabang={form.kodeCabang}
      />
      <ModalBanShow
        open={showBanDetailModal}
        onClose={() => setShowBanDetailModal(false)}
        globalOpsi={globalOpsi}
        idBan={form.idBan}
        reloadToken={resendToken}
      />

      {showTindakLanjutPicker && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1200 }}>
            <div className="modal-dialog modal-xl modal-dialog-centered" style={{ width: "min(1140px, 98vw)" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Pilih Laporan Yang Ditindak Lanjuti</h5>
                  <button type="button" className="btn-close" onClick={() => setShowTindakLanjutPicker(false)} />
                </div>
                <div className="modal-body">
                  <div className="row g-2 align-items-center mb-3">
                    <div className="col-12 col-md-5 col-lg-4">
                      <label className="form-label mb-1">Tampilkan Laporan</label>
                      <select
                        className="form-select form-select-sm"
                        value={tindakLanjutScope}
                        disabled={loadingTindakLanjutRows}
                        onChange={(e) => handleTindakLanjutScopeChange(e.target.value)}
                      >
                        <option value="cabang">
                          {`Cabang ${namaCabangByKode.get(String(form?.kodeCabang || "").trim()) || String(form?.kodeCabang || "").trim()}`}
                        </option>
                        <option value="all">Semua Cabang</option>
                      </select>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle">
                      <thead>
                        <tr>
                          <th>No. Laporan</th>
                          <th>Cabang</th>
                          <th>Jenis</th>
                          <th>No Pol/Seri Ban</th>
                          <th>Topik</th>
                          <th style={{ width: "100px" }}>Pilih</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingTindakLanjutRows && (
                          <tr>
                            <td colSpan={6} className="text-center text-muted">Memuat data...</td>
                          </tr>
                        )}
                        {!loadingTindakLanjutRows && tindakLanjutRows.length === 0 && (
                          <tr>
                            <td colSpan={6} className="text-center text-muted">Tidak ada laporan yang perlu tindak lanjut.</td>
                          </tr>
                        )}
                        {!loadingTindakLanjutRows && tindakLanjutRows.map((row) => (
                          <tr key={`tl-row-${row.id}`}>
                            <td>{String(row?.nomor || "-")}</td>
                            <td>
                              {String(
                                row?.nama_cabang
                                || namaCabangByKode.get(String(row?.kode_cabang || "").trim())
                                || row?.kode_cabang
                                || "-"
                              )}
                            </td>
                            <td>{isMtIdentity(row?.identity) ? "Laporan MT" : "Laporan Ban"}</td>
                            <td>{resolveLaporanIdentityLabel(row)}</td>
                            <td>{String(row?.topik || "-")}</td>
                            <td>
                              <div className="form-check d-flex justify-content-center">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pilih-tindak-lanjut"
                                  checked={String(selectedTindakLanjutNomor || "") === String(row?.nomor || "")}
                                  onChange={() => setSelectedTindakLanjutNomor(String(row?.nomor || ""))}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setShowTindakLanjutPicker(false)}>
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!String(selectedTindakLanjutNomor || "").trim()}
                    onClick={async () => {
                      const picked = (Array.isArray(tindakLanjutRows) ? tindakLanjutRows : [])
                        .find((row) => String(row?.nomor || "") === String(selectedTindakLanjutNomor || ""));
                      if (picked?.id) {
                        const loaded = await loadTindakLanjutChain(picked.id);
                        if (!loaded) return;
                      } else {
                        setSelectedTindakLanjutRow(picked || null);
                        setTindakLanjutHistoryRows([]);
                      }
                      setShowTindakLanjutPicker(false);
                    }}
                  >
                    Gunakan Laporan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" style={{ zIndex: 1190 }} />
        </>
      )}

      <ShowPic
        open={showLampiranTindakLanjut}
        onClose={() => setShowLampiranTindakLanjut(false)}
        row={{}}
        backendPort={backendPort}
        token={token}
        readOnly={true}
        customFiles={tindakLanjutLampiranFiles}
        customTitle="Lampiran Laporan Sebelumnya"
      />

      {showDetailMtPage && selectedMtDetail && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div
            className="page16-modal-card"
            style={{ maxWidth: "min(1200px, 96vw)", width: "96vw", maxHeight: "92vh", overflowY: "auto" }}
          >
            <PageKonten9_Show
              globalOpsi={globalOpsi}
              editData={selectedMtDetail}
              setShowDetail={setShowDetailMtPage}
              setShowMaster={() => {}}
              reloadToken={resendToken}
            />
          </div>
        </div>
      )}

      <ModalTambalDetail
        open={showTambalDetailModal}
        row={activeTambalDetailRow}
        opsiJenisTambal={opsiJenisTambal}
        opsiBahanTambal={opsiBahanTambal}
        onClose={() => {
          setShowTambalDetailModal(false);
          setActiveTambalDetailBanId(0);
        }}
        onSave={(detail) => {
          const idBan = Number(activeTambalDetailBanId || 0);
          if (!idBan) return;
          setSelectedRepairBanRows((prev) => prev.map((row) => (
            Number(row?.id_ban || 0) === idBan
              ? {
                  ...row,
                  jenis_tambal: String(detail?.jenis_tambal || "").trim(),
                  bahan_tambal: String(detail?.bahan_tambal || "").trim(),
                  qty_tambal: Number(detail?.qty_tambal || 0),
                  catatan: String(detail?.catatan || ""),
                }
              : row
          )));
          setShowTambalDetailModal(false);
          setActiveTambalDetailBanId(0);
        }}
      />

      {showTopikModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ zIndex: 1200 }}>
            <div className="modal-dialog modal-dialog-centered" style={{ width: "min(520px, 96vw)" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Input Topik Kejadian Lain</h5>
                  <button type="button" className="btn-close" onClick={() => setShowTopikModal(false)} />
                </div>
                <div className="modal-body">
                  <label className="form-label">Topik</label>
                  <input
                    className="form-control"
                    value={topikBaru}
                    onChange={(e) => setTopikBaru(e.target.value)}
                    placeholder="Masukkan topik kejadian lain"
                  />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setShowTopikModal(false)}>
                    Batal
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleSimpanTopikBaru}>
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" style={{ zIndex: 1190 }} />
        </>
      )}
    </div>
  );
}
